class WithAlert extends HTMLElement {
  alertWrapper = null;
  constructor() {
    super();
    this.alertWrapper = this.querySelector('.form-alerts');
  }

  clearAlerts() {
    this.alertWrapper.classList.remove('error-alert');
    this.alertWrapper.classList.remove('success-alert');
    this.alertWrapper.innerHTML = '';
    this.alertWrapper.classList.remove('mb-custom');
  }

  renderErrors(error) {
    this.alertWrapper.classList.add('alert-visible');
    this.alertWrapper.classList.add('error-alert');

    if (Array.isArray(error)) {
      error.forEach((err) => {
        this.addErrorAlert(err?.message);
      });
    } else if (typeof error == 'string') {
      this.addErrorAlert(error);
    } else if (error?.message) {
      this.addErrorAlert(error.message);
    } else {
      this.addErrorAlert('Something went wrong!');
    }
  }

  renderSuccessAlert(message) {
    this.alertWrapper.classList.add('alert-visible');
    this.alertWrapper.classList.add('success-alert');

    this.#addSuccessAlert(message);
  }

  addErrorAlert(message) {
    if (message === 'Email has already been taken') {
      message = 'This email is associated with another account.';
    }

    const errorItemEl = document.createElement('div');

    errorItemEl.className = 'flex items-center alert-error';

    errorItemEl.innerHTML = `
        <span class="alert-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="m18 6-12 12"/><path d="m6 6 12 12"/></svg>
        </span>
          ${message}`;

    this.alertWrapper.appendChild(errorItemEl);
  }

  #addSuccessAlert(message) {
    const errorItemEl = document.createElement('div');

    errorItemEl.className = 'flex items-center alert-success';

    errorItemEl.innerHTML = `   
      <span class="alert-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-icon lucide-check"><path d="M20 6 9 17l-5-5"/></svg>
      </span>
          ${message}`;

    this.alertWrapper.appendChild(errorItemEl);
  }
}

class ButtonLoader {
  label = null;
  button = null;
  /**
   *
   * @param {HTMLButtonElement} buttonEl
   */
  constructor(buttonEl) {
    this.button = buttonEl;
    this.label = buttonEl.textContent;
  }
  /**
   * Add loader and replate label with the provided loadingText
   * @param {string} loadingText - default is `Processing`
   */
  setLoadingState(loadingText = 'Processing') {
    if (!this.button) throw new Error('Button element is required!');
    this.button.disabled = true;
    this.button.innerHTML = ` 
      <span class="selection-loader animate-spin flex items-center p-4 mr-10">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" class="icon-load">
          <use href="#icon-load"></use>
        </svg>
      </span>
      ${loadingText}
      `;
  }
  /**
   * Revert button label to initial state
   */
  unsetLoadingState() {
    if (!this.button) throw new Error('Button element is required!');
    this.button.disabled = false;
    this.button.innerHTML = this.label;
  }
}

class ShowPassword extends HTMLElement {
  /**
   * The targetted input to toggle the password show functionality
   * @type {HTMLElement | null}
   */
  input = null;
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    this.setupListener();
  }
  init() {
    this.innerHTML = `
    <button class="btn-reset password-toogle-btn" type="button" tabindex="-1">
        <span id="eye">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-icon lucide-eye"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/>
            <circle cx="12" cy="12" r="3"/>
        </svg>
        </span>
        <span id="eye-closed">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-off-icon lucide-eye-off"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"/><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"/><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"/><path d="m2 2 20 20"/></svg>
        </span>
    </button>
    `;

    this.input = document.querySelector(this.dataset.inputSelector);
  }

  setupListener() {
    const toogleButton = this.querySelector('.password-toogle-btn');

    if (!toogleButton) return;

    toogleButton.addEventListener('click', () => {
      if (this.input) {
        this.applyToogle();
      }
    });

    if (this.input) {
      this.input.addEventListener('focus', (e) => {
        toogleButton.style.opacity = 1;
        toogleButton.disabled = false;
      });

      this.input.addEventListener('keydown', (e) => {
        if (e.code === 'Tab') {
          toogleButton.style.opacity = 0;
          toogleButton.disabled = true;
        }
      });

      // Click outside listener
      document?.addEventListener('click', (e) => {
        const isClickInsideInput = this.input.contains(e.target);
        const isClickInsideButton = toogleButton.contains(e.target);
        const isFocusedInput = document.activeElement === this.input;

        if (!isClickInsideInput && !isClickInsideButton && !isFocusedInput) {
          toogleButton.style.opacity = 0;
          toogleButton.disabled = true;
        }
      });
    }
  }

  applyToogle() {
    if (this.dataset.passwordShown === 'true') {
      this.dataset.passwordShown = false;
      this.input.type = 'password';
    } else {
      this.dataset.passwordShown = true;
      this.input.type = 'text';
    }
  }
}

customElements.define('show-password', ShowPassword);
